import { RootState } from '@atredux/store'
import { Locale } from '@atredux/slices/localeSlice'

export const getSelectedLocale = (state: RootState): Locale => state.locale.locale
